import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaComments, FaUser } from 'react-icons/fa';
import DOMPurify from 'dompurify';

export const BlogMain = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/blogs/`)
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then((data) => {
        setBlogs(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="py-12 text-center">Loading...</div>;
  if (error) return <div className="py-12 text-center text-red-600">Error: {error}</div>;

  return (
    <div className="min-h-screen px-4 py-12 md:px-10 lg:px-20">
      {/* Changed container to row for Bootstrap columns */}
      <div className="row">
        {blogs.map(blog => (
          // Blog One Single Start
          <div key={blog.id} className="col-xl-4 col-lg-4 wow fadeInLeft" data-wow-delay="100ms">
            <Link to={`/blog-details/${blog.slug}`}>
              <div className={blog.blogClass ? blog.blogClass : "blog-one__single"} style={{ boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                <div className="blog-one__img-box">
                  <div className="blog-one__img">
                    <img src={blog.image} alt={blog.title} />
                  </div>
                  <div className="blog-one__date">
                    <p>{blog.date ? blog.date : "24 March"}</p>
                  </div>
                </div>
                <div className="blog-one__content">
                  <h3 className="blog-one__title">
                    {blog.title ? blog.title : "Title not found"}
                  </h3>
                  <p className="blog-one__text">
                    {blog.headline ? blog.headline : "Title not found"}
                  </p>
                  <div className="blog-one__read-more">
                    <Link to={`/blog-details/${blog.slug}`}>
                      Read More
                      <span className="icon-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          /* Blog One Single End */
        ))}
      </div>
    </div>
  );
};

